// src/components/ChartsWidget/ChartsWidget.js
import React from 'react';
import './ChartsWidget.scss';

const ChartsWidget = ({ NotesData }) => {
  return (
    <div className="charts-widget-notes">
      <h3>Notes Overview</h3>
      <div className="notes-grid">
        {NotesData?.length === 0 ? (
          <p className="no-notes">No notes available.</p>
        ) : (
          NotesData?.map(note => (
            <div key={note._id} className="note-card">
              <div className="note-header">
                <h4>{note.title}</h4>
              </div>
              <div className="note-body">
                <p>{note.content}</p>
              </div>
              <div className="note-footer">
                <span>🏛 {note.courtRef}</span>
                <span>📅 {new Date(note.updatedAt).toLocaleDateString()}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ChartsWidget;
